import styled from "styled-components"
import { Toggle, Select } from 'linkdrop-ui'

import { Button } from 'components/common'

export const SelectStyled = styled(Select)`
  margin-bottom: 32px;
`

export const Content = styled.div``

export const CountryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  margin-bottom: 16px;
`

export const ButtonStyled = styled(Button)`
`